<template>
  <div class="pageWrapper_home">
    <div class="fan_massage">
      <div class="top_header">
        <div class="back-icon" @click="goBack()">
          <i class="material-icons">arrow_back</i>
        </div>
        <div class="container">
          <Header update_profile_txt=" Update Your Profile" icon_txt="arrow_forward" />
          <div class="title_acceptedMessage">
            <!-- <h1>{{$t('acceptedMessage')}} ({{acceptedRequestList.length}})</h1> -->

            <h1>{{$t('acceptedMessage')}} ({{accepted_count}})</h1>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="middlePannel_acceptedMessage middlePannel_acceptedMessage1">
          <!-- <span v-if="!acceptedRequestList.length" class="no_data">{{$t('noDataAvailable')}}!</span> -->
          <ul>
            <li v-for="acceptedRequest in acceptedRequestList" :key="acceptedRequest.request_id">
              <span class="earn1_badge">
                <img
                  :src="acceptedRequest.user_profile_pic"
                  v-if="acceptedRequest.user_profile_pic"
                />
                <img src="../assets/images/user_images.png" v-else />
              </span>
              <div class="details_acceptedMessage">
                <span>{{acceptedRequest.user}} {{$t('wantsVideo')}} {{acceptedRequest.request_for}}</span>
                <span class="day_time">{{acceptedRequest.request_time}}</span>
                <span class="fan_message">{{acceptedRequest.message}}</span>
                <!-- <span class="approved">Profile approved of {{acceptedRequest.time}}</span> -->
              </div>
              <div class="buttons">
                <Btn
                  :btn_txt="$t('btnViewProfile')"
                  btn_cls="viewProfile-btn"
                  @goToFanDetailsCallback="viewFanProfile(acceptedRequest, acceptedRequest.request_id, acceptedRequest)"
                />
              </div>
            </li>
          </ul>
          <infinite-loading @infinite="acceptedMessageList">
            <template slot="no-more">{{ $t("NoRecordsavailable") }}</template>
          </infinite-loading>
        </div>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "../components/Header";
import Btn from "../components/Btn";
import Footer from "../components/Footer";
import { toaster } from "../utils/helper";
import ApiCaller from "../utils/apicaller";
import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";
Vue.use(InfiniteLoading);
export default {
  name: "AcceptedMessages",
  components: {
    Footer,
    Btn,
    Header,
    InfiniteLoading
  },
  data() {
    return {
      celebrity_id: "",
      acceptedRequestList: [],
      showAcceptedRequest: [],
      loading: false,
      limit: 0,
      accepted_count: 0
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    viewFanProfile(accept_request, id, acp) {
      sessionStorage.setItem("request_detail", JSON.stringify(accept_request));
      this.$router.push({
        path: `/fan-details/${id}`,
        query: { req: acp, uploadBtn: true }
      });
    },
    acceptedMessageList($state) {
      ApiCaller(`/celebrity/accepted/${this.limit}/10`, "get").then(data => {
        if (data.data.length) {
          this.limit += 10;
          this.acceptedRequestList = this.acceptedRequestList.concat(data.data);
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }
      });
    }
  },
  mounted() {
    this.$store
      .dispatch({ type: "totalUploadedVideos" })
      .then(data => {
        this.videos = data.data.total_videos;
        this.accepted_count = data.data.accepted_count;
      })
      .catch(err => {
        this.loading = !this.loading;
      });
  }
};
</script>


